'use client';
import Link from 'next/link';
import * as Styled from './styled';
import * as Icon from '@/ui/Icon';

type PathLink = { name: React.ReactNode; href: string };

const BreadCrumbItem: React.FC<{ pathLink: PathLink; pathSize: number; index: number }> = ({
  pathLink,
  // activeEntry,
  pathSize,
  index,
}) => {
  const position = index + 1;
  return (
    <>
      <Styled.BreadCrumbItem key={pathLink.href}>
        {position < pathSize ? <Link href={pathLink.href}>{pathLink.name}</Link> : <span>{pathLink.name}</span>}
      </Styled.BreadCrumbItem>
      {position < pathSize && <span className="seperator">/</span>}
    </>
  );
};

const BreadCrumbs: React.FC<{ items: PathLink[]; icon?: React.ReactNode; style?: React.CSSProperties }> = ({
  items,
  icon = <Icon.Compass />,
  ...rest
}) => {
  return (
    <Styled.BreadCrumbs {...rest}>
      {icon}
      <Styled.BreadCrumbItems>
        {items.map((pathLink, index) => (
          <BreadCrumbItem
            key={pathLink.href}
            pathLink={pathLink}
            // activeEntry={activeEntry}
            pathSize={items.length}
            index={index}
          />
        ))}
      </Styled.BreadCrumbItems>
    </Styled.BreadCrumbs>
  );
};

export default BreadCrumbs;
